import { FC, useState } from "react";
import { FAQGroup } from "@/data/membershipsFAQData";
import CollapsibleItem from "@/components/Collapsible/CollapsibleItem";

interface FAQFullPageProps {
  title?: string;
  groups: FAQGroup[];
}

const FAQFullPage: FC<FAQFullPageProps> = ({
  title = "Dažnai užduodami klausimai",
  groups,
}) => {
  const [openItemId, setOpenItemId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenItemId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="w-full bg-white px-4 md:px-6">
      <div className="mx-auto w-full max-w-[1200px]">
        <h2 className="text-dark text-center text-[34px] leading-[1.2] font-light md:text-[44px]">
          {title}
        </h2>

        <div className="flex flex-col">
          {groups.map((group, groupIdx) => {
            const isLast = groupIdx === groups.length - 1;
            return (
              <div
                key={group.number}
                className={`flex flex-col gap-8 py-7.5 md:flex-row md:justify-between md:py-[60px] ${
                  isLast ? "" : "border-b border-[#E7E7E7]"
                }`}
              >
                <div className="flex shrink-0 items-center gap-5 pt-[25px] md:items-start">
                  <span className="text-body text-base leading-[1.5]">
                    {group.number}
                  </span>
                  <span className="text-muted text-base leading-[1.5]">
                    {group.label}
                  </span>
                </div>

                <div className="w-full md:max-w-[755px]">
                  {group.items.map((item, idx) => (
                    <CollapsibleItem
                      key={item.id}
                      id={item.id}
                      label={item.label}
                      description={item.description}
                      itemClassName="text-base font-normal"
                      isOpen={openItemId === item.id}
                      isLast={idx === group.items.length - 1}
                      onToggle={() => handleToggle(item.id)}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQFullPage;
